import React from 'react'
import { toastInfo } from '../utils/toast'
import { toast } from 'react-toastify'
import { Answer } from '../apis/entities/answer.entity'
import { StyleUtil } from '../utils/StyleUtil'
import { useDataContext } from '../context/DataProvider'

interface Props {
  callback: (questionId: string, answerId: string) => void
  questionText: string
  answers: Answer[]
  questionNumber: number
  questionId?: string
  submitText?: string
}

const MultipleChoiceCard: React.FC<Props> = ({
  callback,
  questionText,
  answers,
  questionNumber,
  questionId,
  submitText = 'Submit',
}) => {
  const { submitAnswer } = useDataContext()
  const [answerId, setAnswerId] = React.useState<string>()
  const submittedQuestionId = questionId ?? ''

  function onClickMultipleChoiceItem(
    questionId: string,
    answerId: string,
  ): void {
    setAnswerId(answerId)
    // console.log('onClickMultipleChoiceItem', questionId, answerId)
  }

  async function onClickMultipleChoiceSubmit(
    questionId: string,
    answerId: string | undefined,
  ) {
    if (answerId !== undefined) {
      await submitAnswer(questionId, questionNumber, answerId)
      toast.dismiss()
      callback(questionId, answerId)
      setAnswerId(undefined)
    } else {
      toastInfo(`Please select an answer to continue`)
    }
  }

  return (
    <div className="">
      <div className="border border-bgMuted pt-3 pb-9 px-9 w-[632px] mx-auto">
        <p className="border-b border-bgMuted py-6 px-3 font-bold">
          {questionText}
        </p>

        {answers.map((answer, index) => (
          <div className="font-roboto" id="mc-answers" key={`chc-${index}`}>
            <div
              data-testid="mc-item"
              className="mc-item flex items-center gap-3 py-[18px] px-3 border border-transparent hover:border-black"
              onClick={() =>
                onClickMultipleChoiceItem(submittedQuestionId, answer.id)
              }
            >
              <input
                type="radio"
                id={`${answer.id}`}
                name={`group-${questionId}`}
                value="Insert correct answer to question 1"
                data-correct="yes"
                data-result="Insert feedback a learner sees if they select this option"
                checked={answerId === answer.id}
                readOnly
              />
              <label className="" htmlFor={`${answer.id}`}>
                {answer.text}
              </label>
            </div>
          </div>
        ))}
        <div className="flex justify-center pt-3">
          <button
            data-testid="btn-submit"
            className={
              answerId
                ? StyleUtil.buttonPrimaryUnsw
                : StyleUtil.blackBorderNothing
            }
            onClick={() =>
              onClickMultipleChoiceSubmit(submittedQuestionId, answerId)
            }
          >
            {submitText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default MultipleChoiceCard
